import React, { useEffect } from "react";
import {
  MainDoorValidation,
  ElementValidation,
  WindowValidation,
  LevelingValidation,
  MiscellaneousValidation,
} from "../component/MainDoor";
import { useNavigate, useLocation } from "react-router-dom";
import { Button } from "react-bootstrap";
import { vasthuUrl } from "../component/Api";
import MyAccordian from "../component/MyAccordian";
import { UseVasthu } from "../context/vasthu";
import { useTranslation } from "react-i18next";
import HelmetSeo from "../component/HelmetSeo";

const HomeValidation = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const location = useLocation();
  const token = window.sessionStorage.getItem("token");
  const { homeRec } = UseVasthu();
  const myAccordian = [
    { label: t("USR.HOM.RES.MAI.DOR"), content: MainDoorValidation },
    { label: t("USR.VSH.RES.ACR.ELM"), content: ElementValidation },
    { label: t("USR.VSH.STP.4"), content: MiscellaneousValidation },
    { label: t("USR.VSH.STP.3"), content: WindowValidation },
    { label: t("USR.HOM.RES.LEV"), content: LevelingValidation },
  ];

  console.log("MyAccordian", MyAccordian);

  useEffect(() => {
    vasthuUrl
      .get(`/subscription/useVasthuOffer/${location.state.offerId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((rs) =>
        console.log("offer subscription redeem count used", rs.data.message)
      )
      .catch((er) =>
        console.log("offer subscription redeem count not reduced", er)
      );
  });

  return (
    <React.Fragment>
      <HelmetSeo
        title="Home Validation | Vasthuparam"
        content="Validate your home using Vasthu principles and Vedic astrology to assess energy flow, directional alignment, and structural harmony."
        name="description"
        relCa="canonical"
        hrefCa="https://www.vasthuparam.com/homevalidation"
        relAl="alternate"
        hrefAl="https://m.www.vasthuparam.com/homevalidation"
      />

      {myAccordian.map((item) => {
        return (
          <MyAccordian
            className="myAccordian accordian_style"
            label={item.label}
            content={<item.content data={homeRec} />}
          />
        );
      })}
      <center>
        <Button
          variant="outline-warning"
          style={{ borderRadius: 50 }}
          onClick={() => navigate("/buildingdetails")}
          className="mt-2"
        >
          {t("BTN.FIN.UP")}
        </Button>
      </center>
    </React.Fragment>
  );
};
export default HomeValidation;
